import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "box-input escape-confirm" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "txt-danger txt-required"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "*", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["value", "type", "placeholder", "autocomplete", "rows"]
const _hoisted_10 = ["value", "type", "placeholder", "autocomplete", "min", "rows"]
const _hoisted_11 = {
  key: 2,
  class: "tel-prefix"
}
const _hoisted_12 = {
  key: 1,
  class: "mb0 txt-danger font14 mt3"
}

export function render(_ctx, _cache) {
  const _component_text_editor = _resolveComponent("text-editor")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.updatedLabel,
          class: "txt-ellipsis bold"
        }, [
          _createTextVNode(_toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.textEditor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_text_editor, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
              readonly: _ctx.readonly,
              isError: _ctx.isError ? true : false,
              placeholder: _ctx.placeholder ? _ctx.placeholder : 'componentWriteSomething',
              editorOption: _ctx.editorOption,
              onUpdate: _cache[1] || (_cache[1] = $event => (_ctx.updateEditor($event)))
            }, null, 8, ["modelValue", "readonly", "isError", "placeholder", "editorOption"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  value: _ctx.value,
                  type: _ctx.validateType(_ctx.type === 'number' ? 'text' : _ctx.type),
                  placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : _ctx.$t('componentWriteSomething'),
                  class: _normalizeClass([{ 'outline-danger': _ctx.isError, pl46: _ctx.type == 'tel' }, "input is_readonly"]),
                  ref: _ctx.refIds,
                  autocomplete: _ctx.autocompleteValue,
                  readonly: "",
                  rows: _ctx.rows
                }, null, 10, _hoisted_9))
              : (_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  value: _ctx.value,
                  onKeyup: [
                    _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
                    _cache[3] || (_cache[3] = $event => (_ctx.onKeypress($event)))
                  ],
                  onKeypress: _cache[4] || (_cache[4] = $event => (_ctx.onKeypress($event))),
                  onChange: _cache[5] || (_cache[5] = $event => (_ctx.onKeypress($event))),
                  onInput: _cache[6] || (_cache[6] = $event => (_ctx.onEmits($event))),
                  onKeydown: _cache[7] || (_cache[7] = (...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
                  type: _ctx.validateType(_ctx.type === 'number' ? 'text' : _ctx.type),
                  placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : _ctx.$t('componentWriteSomething'),
                  class: _normalizeClass([{ 'outline-danger': _ctx.isError, pl30: _ctx.type == 'tel' }, "input editor"]),
                  ref: _ctx.refIds,
                  autocomplete: _ctx.autocompleteValue,
                  min: _ctx.minDate || '',
                  rows: _ctx.rows
                }, null, 42, _hoisted_10))
          ])),
      (_ctx.type == 'tel')
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "0"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isError)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}